import { LOCALES } from 'i18n/locales';

export const enquiryAlertModalIntl = {
    [LOCALES.ENGLISH]: {
        'enquiryAlerts.modal.button.save.text': 'Accept and continue',
        'enquiryAlerts.modal.delete.title': 'Delete Enquiry',
        'enquiryAlerts.modal.delete.body': 'Are you sure you want to delete "{title}"? This action cannot be undone.',
        'enquiryAlerts.modal.button.delete.text': 'Delete',
        'enquiryAlerts.modal.button.cancel.text': 'Cancel'
    },
    [LOCALES.WELSH]: {
        'enquiryAlerts.modal.button.save.text': '[Accept and continue]',
        'enquiryAlerts.modal.delete.title': '[Delete Enquiry]',
        'enquiryAlerts.modal.delete.body': '[Are you sure you want to delete "{title}"? This action cannot be undone.]',
        'enquiryAlerts.modal.button.delete.text': '[Delete]',
        'enquiryAlerts.modal.button.cancel.text': '[Cancel]'
    }
};
